import React, { useState } from 'react';
import { BMPProvider, useBMP } from './context/BMPContext';
import BMPHeader from './layout/BMPHeader';
import BMPSidebar from './layout/BMPSidebar';
import BMPFooter from './layout/BMPFooter';
import CatalogView from './views/CatalogView';
import QuotaDetailView from './views/QuotaDetailView';
import DashboardView from './views/DashboardView';
import ProfileView from './views/ProfileView';
import AnalyticsView from './views/AnalyticsView';
import ProducerStoreView from './views/ProducerStoreView';
import { useTranslation } from 'react-i18next';
import './BMPApp.css';

function BMPContent() {
  const { t } = useTranslation();
  const { profile, profileLoading, bmpView, bmpNavigate } = useBMP();

  if (profileLoading) {
    return <div className="bmp-loading">{t('loading_dots')}</div>;
  }

  // Onboarding — no profile yet
  if (!profile && bmpView !== 'profile') {
    return (
      <div className="bmp-onboarding">
        <div className="bmp-onboarding-card">
          <h1>{t('bmp_welcome_title')}</h1>
          <p>{t('bmp_welcome_desc')}</p>
          <div className="bmp-onboarding-roles">
            <div className="bmp-role-option" onClick={() => bmpNavigate('profile', { defaultRole: 'productor' })}>
              <span className="bmp-role-option-icon">&#127793;</span>
              <strong>{t('mkt_producer')}</strong>
              <span>{t('bmp_role_producer_desc')}</span>
            </div>
            <div className="bmp-role-option" onClick={() => bmpNavigate('profile', { defaultRole: 'exportadora' })}>
              <span className="bmp-role-option-icon">&#128674;</span>
              <strong>{t('mkt_exporter')}</strong>
              <span>{t('bmp_role_exporter_desc')}</span>
            </div>
            <div className="bmp-role-option" onClick={() => bmpNavigate('profile', { defaultRole: 'comercial' })}>
              <span className="bmp-role-option-icon">&#129309;</span>
              <strong>{t('mkt_commercial')}</strong>
              <span>{t('bmp_role_commercial_desc')}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  switch (bmpView) {
    case 'catalog':
      return <CatalogView />;
    case 'quota_detail':
      return <QuotaDetailView />;
    case 'producer_store':
      return <ProducerStoreView />;
    case 'farms':
    case 'my_quotas':
    case 'received_bids':
    case 'my_bids':
    case 'transactions':
      return <DashboardView />;
    case 'profile':
      return <ProfileView />;
    case 'analytics':
      return <AnalyticsView />;
    default:
      return <CatalogView />;
  }
}

export default function BMPApp({ userInfo, onExitMarketplace, onLogout }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <BMPProvider userInfo={userInfo}>
      <div className="bmp-shell">
        <BMPHeader
          onExit={onExitMarketplace}
          onToggleSidebar={() => setSidebarOpen(v => !v)}
        />
        <div className="bmp-body">
          <BMPSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
          <main className="bmp-main">
            <BMPContent />
          </main>
        </div>
        <BMPFooter />
      </div>
    </BMPProvider>
  );
}
